<template>
  <img
    :src="blankPlaceholder"
    :data-src="lazySrc"
    :data-srcset="lazySrcset"
    :style="style"
    :class="['c-lazy-image', round ? 'is-round' : '']"
  >
</template>

<script>
import 'intersection-observer';
import lozad from 'lozad';

export default {
  props: {
    height: {
      type: Number,
      default: null,
    },
    lazySrc: {
      type: String,
      default: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
    },
    lazySrcset: {
      type: String,
      default: 'null',
    },
    width: {
      type: Number,
      default: null,
    },
    round: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      blankPlaceholder: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
      loading: true,
    };
  },
  computed: {
    aspectRatio() {
      if (!this.width || !this.height) return null;
      return (this.height / this.width) * 100;
    },
    style() {
      const style = {};

      if (this.width) style.width = `${this.width}px`;

      const applyAspectRatio = this.loading && this.aspectRatio;

      if (applyAspectRatio) {
        style.height = 0;
        style.paddingTop = `${this.aspectRatio}%`;
      }

      return style;
    },
  },
  mounted() {
    const setLoadingState = () => {
      this.loading = false;
    };
    this.$el.addEventListener('load', setLoadingState);
    this.$once('hook:destroyed', () => {
      this.$el.removeEventListener('load', setLoadingState);
    });
    const observer = lozad('.c-lazy-image', {
      rootMargin: '10px 0px',
      threshold: 0.1,
    });
    observer.observe();
  },
};
</script>
